import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyWorkerState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="bg-gray-100 rounded-full p-6 mb-4">
        <Inbox className="w-16 h-16 text-gray-400" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        No Projects Assigned Yet
      </h3>
      <p className="text-gray-600 text-center max-w-md mb-4">
        You don't have any assigned projects at the moment. Your project manager will assign you to projects soon.
      </p>
      <p className="text-sm text-gray-500 text-center max-w-md">
        Once assigned, you'll be able to view your phases, upload progress documentation, 
        and collaborate with other trades on the 3M progress.
      </p>
    </div>
  );
};

export default EmptyWorkerState;